import { ReactNode, useCallback, useEffect, useState } from 'react';

import { useAppbarStore, useResponsive } from '@zeta-core';
import ManagedClientNavigation from './managed-client-navigation';
import DashboardContainer from '../dashboard-layout/dashboard-container';
import { DASHBOARD_CONFIG } from '../common/constants';
import { useMutation } from '@tanstack/react-query';
import { IClientCardItem, IEmptyRequestResponse, IGetAdvisorUserListResponse } from '@zeta-types';
import { MessagingService } from '@zeta-services';
import { AxiosResponse } from 'axios';
import { useLocation } from 'react-router';
import { Drawer } from '@mui/material';

interface IManagedClientLayoutType {
  children: ReactNode;
}

const ManagedClientLayout = ({ children }: IManagedClientLayoutType) => {
  const location = useLocation();
  const locationState = (location.state || {}) as { entityData: IClientCardItem; clientData: IClientCardItem };
  const lgUp = useResponsive('up', 'lg');
  const [messageCount, setMessageCount] = useState(0);
  const sidebarOpen = useAppbarStore((state) => state?.sidebarOpen);
  const updateAppbar = useAppbarStore((state) => state?.updateAppbarStore);
  const [advisorUserList, setAdvisorUserList] = useState<IGetAdvisorUserListResponse>();

  const handleCloseSidebar = () => updateAppbar({ sidebarOpen: false });

  const getMessageCount = useMutation({
    mutationFn: (payload: IEmptyRequestResponse) => MessagingService().getMessageCount(payload),
    onSuccess: (response: AxiosResponse<{ unread: number }>) => {
      setMessageCount(response?.data?.unread || 0);
    },
  });

  const fetchMessages = useCallback(() => {
    const payload: IEmptyRequestResponse = {
      fromEntityID: locationState?.clientData?.clientID,
    };
    getMessageCount.mutateAsync(payload);
  }, [locationState?.clientData?.clientID]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  return (
    <>
      {lgUp ? (
        <ManagedClientNavigation messageCount={messageCount || 0} advisorUserList={advisorUserList} setAdvisorUserList={setAdvisorUserList} />
      ) : (
        <Drawer
          open={sidebarOpen}
          onClose={handleCloseSidebar}
          slotProps={{
            paper: {
              sx: {
                width: DASHBOARD_CONFIG.NAVIGATION.DESKTOP_WIDTH,
              },
            }
          }}
        >
          <ManagedClientNavigation messageCount={messageCount || 0} advisorUserList={advisorUserList} setAdvisorUserList={setAdvisorUserList} />
        </Drawer>
      )}
      <DashboardContainer sx={{ ml: lgUp ? DASHBOARD_CONFIG.NAVIGATION.DESKTOP_WIDTH / 8 : 0 }} variant="sm">
        {children}
      </DashboardContainer>
    </>
  );
};

export default ManagedClientLayout;
